import FormUserView from 'User/Application/Views/FormUserView';
import TableUserView from 'User/Application/Views/TableUserView';
import { PRIVATE_USER_FORM_USER, PRIVATE_USER_LIST_USERS, PROPOSAL_PROJECT, APPLICATIONS_USER, PORTAL_USER, PRIVATE_USER_VALIDATION_ORGCHARTS, IMPROVEMENT_PROPOSAL, IMPROVEMENT_CHANNEL, DELEGATION_SERVICE } from 'User/Application/Constants/PathsConstant';
import { PRIVATE_PROPOSAL_PROJECT_FORM } from 'ProposalProject/ProposalProject/Application/Constants/PathsConstant';
import ProposalProject from 'ProposalProject/ProposalProject/Application/Views/TableProposalProjectView';
import FormProposalProjectView from 'ProposalProject/ProposalProject/Application/Views/FormProposalProjectView';
import FormImprovementProposalView from 'ImprovementProposal/Application/Views/FormImprovementProposalView';
import ImprovementProposalApprovalView from 'ImprovementProposal/Application/Views/ImprovementProposalApprovalView';
import ImprovementProposalTrackingView from 'ImprovementProposal/Application/Views/ImprovementProposalTrackingView';
import ImprovementProposalHistoryView from 'ImprovementProposal/Application/Views/ImprovementProposalHistoryView';
import ImprovementChannelLandingView from 'ImprovementProposal/Application/Views/ImprovementChannelLandingView';
import { PRIVATE_IMPROVEMENT_PROPOSAL_APPROVAL, PRIVATE_IMPROVEMENT_PROPOSAL_TRACKING, PRIVATE_IMPROVEMENT_PROPOSAL_HISTORY } from 'ImprovementProposal/Application/Constants/PathsConstant';
import { PRIVATE_CS_ALERT_CONFIGURATION } from 'CS/Application/Constants/PathsConstant';
import TableCSAlertConfigurationView from 'CS/Application/Views/TableCSAlertConfigurationView';
import ApplicationsUserView from 'UI/Application/Views/ApplicationsUserView';
import PortalUserView from 'UI/Application/Views/PortalUserView';
import ValidationOrgChartsView from 'OrgChart/Application/Views/ValidationOrgChartsView';
import {
  PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE, PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE,
  PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE, PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE,
  PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE, PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE, PRIVATE_USER_LIST_SERVICE_COMPANY, PRIVATE_USER_FORM_SERVICE_COMPANY,
   PRIVATE_USER_GESTION_DE_SERVICIOS, PRIVATE_USER_SERVICIOS_CONTRATADOS,
   PRIVATE_USER_DELEGATION,
} from "DelegationService/DelegationService/Application/Constants/PathsConstants.js";
import TableUnionDelegationServiceView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/UnionDelegationService/TableUnionDelegationServiceView';
import FormUnionDelegationServiceView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/UnionDelegationService/FormUnionDelegationServiceView';
import FormServiceContractDelegationView from 'DelegationService/DelegationService/Application/Views/ContractedServices/ServiceContractDelegation/FormServiceContractDelegationView';
import TableServiceContractDelegationView from 'DelegationService/DelegationService/Application/Views/ContractedServices/ServiceContractDelegation/TableServiceContractDelegationView';
import FormServiceContactDelegationView from 'DelegationService/DelegationService/Application/Views/ContractedServices/ServiceContactDelegation/FormServiceContactDelegationView';
import TableServiceCompanyView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/ServiceCompany/TableServiceCompanyView';
import FormServiceCompanyView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/ServiceCompany/FormServiceCompanyView';
import TableContactDelegationServiceView from 'DelegationService/DelegationService/Application/Views/ContractedServices/ServiceContactDelegation/TableServiceContactDelegationView';
import ServiceDelegationLandingView from 'DelegationService/DelegationService/Application/Views/ServiceDelegationLandingView';
import ServiceManagmentLandingView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/ServiceManagementLandingView';
import ContactedServiceLandingView from 'DelegationService/DelegationService/Application/Views/ContractedServices/ContractedServiceLandingView';
import TableDelegationView from 'DelegationService/DelegationService/Application/Views/ServiceManagment/Delegation/TableDelegationView';
export const UserRouter = [
  {
    path: PRIVATE_USER_LIST_USERS,
    element: <TableUserView />,
    children: []
  },
  {
    path: PRIVATE_USER_FORM_USER + '/:id',
    element: <FormUserView />,
    children: []
  },
  {
    path: PROPOSAL_PROJECT,
    element: <ProposalProject />,
    children: []
  },

  {
    path: IMPROVEMENT_CHANNEL,
    element: <ImprovementChannelLandingView />,
    children: []
  },
  {
    path: PRIVATE_IMPROVEMENT_PROPOSAL_APPROVAL,
    element: <ImprovementProposalApprovalView />,
    children: []
  },
  {
    path: PRIVATE_IMPROVEMENT_PROPOSAL_TRACKING,
    element: <ImprovementProposalTrackingView />,
    children: []
  },
  {
    path: PRIVATE_IMPROVEMENT_PROPOSAL_HISTORY,
    element: <ImprovementProposalHistoryView />,
    children: []
  },
  {
    path: PRIVATE_PROPOSAL_PROJECT_FORM + '/:id',
    element: <FormProposalProjectView />,
    children: []
  },
  {
    path: IMPROVEMENT_PROPOSAL + '/:id',
    element: <FormImprovementProposalView />,
    children: []
  },
  {
    path: IMPROVEMENT_CHANNEL + '/:id',
    element: <FormImprovementProposalView />,
    children: []
  },
  {
    path: PRIVATE_CS_ALERT_CONFIGURATION,
    element: <TableCSAlertConfigurationView />,
    children: []
  },
  {
    path: APPLICATIONS_USER,
    element: <ApplicationsUserView />,
    children: []
  },
  {
    path: PORTAL_USER,
    element: <PortalUserView />,
    children: []
  },
  {
    path: PRIVATE_USER_VALIDATION_ORGCHARTS,
    element: <ValidationOrgChartsView />,
    children: []
  },
  {
    path: DELEGATION_SERVICE,
    element: <ServiceDelegationLandingView />,
    children: []

  },
 
   {
    path: PRIVATE_USER_GESTION_DE_SERVICIOS,
    element: <ServiceManagmentLandingView />,
    children: []

  },
     {
    path: PRIVATE_USER_SERVICIOS_CONTRATADOS,
    element: < ContactedServiceLandingView />,
    children: []

  },
  {
    path: PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE,
    element: <TableUnionDelegationServiceView />,
    children: []
  },
  {
    path: PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE + '/:id',
    element: <FormUnionDelegationServiceView />,
    children: []
  },
  {
    path: PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE + '/:id',
    element: <FormServiceContractDelegationView />,
    children: []
  },
  {
    path: PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE,
    element: <TableServiceContractDelegationView />,
    children: []
  },
  {
    path: PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE,
    element: <TableContactDelegationServiceView />,
    children: []
  },
  {
    path: PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE + '/:id',
    element: <FormServiceContactDelegationView />,
    children: []
  },
  {
    path: PRIVATE_USER_LIST_SERVICE_COMPANY,
    element: <TableServiceCompanyView />,
    children: []
  },
  {
    path: PRIVATE_USER_FORM_SERVICE_COMPANY + '/:id',
    element: <FormServiceCompanyView />,
    children: []
  },
  {
        path: PRIVATE_USER_DELEGATION,
        element: <TableDelegationView />,
        children: []
    },
];